import { FC, ReactNode, useState } from 'react';
import { Avatar } from 'antd';
import { TbArrowUpRight, TbWorldWww } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { corporateLogo } from '@/utilities';

interface EnrichedAnchorTagProps {
    url: string;
    label: ReactNode;
}

const EnrichedAnchorTag: FC<EnrichedAnchorTagProps> = ({ url, label }): JSX.Element => {
    const { token } = useAntDesignTheme();
    const [failedLogoUrl, setFailedLogoUrl] = useState<string>();
    const logoUrl = corporateLogo(url);
    const resolvedLogoUrl = logoUrl === failedLogoUrl ? undefined : logoUrl;

    return (
        <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            style={{
                alignItems: 'center',
                display: 'inline-flex',
                fontSize: 'inherit',
                gap: '0.25rem',
                lineHeight: 'inherit',
                marginLeft: '0.125rem',
                color: 'inherit',
                textDecoration: 'underline',
                textDecorationColor: token.colorTextTertiary,
                verticalAlign: 'baseline',
                whiteSpace: 'nowrap',
            }}
        >
            <Avatar
                aria-hidden='true'
                icon={
                    resolvedLogoUrl ? undefined : (
                        <TbWorldWww data-testid='enriched-anchor-logo-fallback' size='0.75rem' />
                    )
                }
                onError={() => {
                    setFailedLogoUrl(logoUrl);
                    return false;
                }}
                size={16}
                shape='square'
                src={resolvedLogoUrl}
                style={{
                    background: token.colorBgContainer,
                    border: `1px solid ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    color: token.colorTextTertiary,
                    flex: '0 0 1rem',
                    fontSize: '0.75rem',
                }}
            />
            <span style={{ color: token.colorTextTertiary }}>{label}</span>
            <TbArrowUpRight aria-hidden='true' size='1em' style={{ color: token.colorTextTertiary, flex: 'none' }} />
        </a>
    );
};

export default EnrichedAnchorTag;
